export default "__VITE_ASSET__39e93d33__"